module.exports = __webpack_public_path__ + "fj.57aaef5c5e7b9e2489d8.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/fj.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/fj.svg
// module chunks = styles